import { SxProps } from '@mui/material';
import { Box } from '@mui/material';
import * as Preact from 'preact';

export interface Props {
    imageUrl: string;
    sx?: SxProps;
}

export const Component = (p: Props) => {
    return (
        <Box
            sx={{
                backgroundImage: `url(${p.imageUrl})`,
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center',
                height: '100%',
                width: '100%',
                borderRadius: '8px',
                ...p.sx,
            }}
        />
    );
};

Component.displayName = 'LoadingImage';
